var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift",on:{"click":function($event){}}},[_vm._m(0),_c('div',{staticClass:"gift__texts"},[_c('p',{staticClass:"gift__name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('p',{staticClass:"gift__desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift__icon"},[_c('img',{attrs:{"src":require("@/assets/png/gift.png"),"alt":"gift"}})])
}]

export { render, staticRenderFns }